import { md5, util } from 'node-forge';
export const createMd5Calculator = () => {
    return nodeForgeMd5HashCalculator;
};
function nodeForgeMd5HashCalculator(data) {
    const encodedData = util.binary.raw.encode(data);
    const md = md5.create();
    md.update(encodedData);
    const binaryString = md.digest().getBytes();
    const res = util.binary.raw.decode(binaryString);
    return res;
}
